import { http } from "@/api/client";
import type { ApiItemResponse, ApiListResponse } from "@/api/types";
import type { LandingPage, Temple } from "@/types/domain";

export const contentApi = {
  listTemples: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<Temple>>("/api/temples", query),
  getTemple: (id: string) => http.get<ApiItemResponse<Temple>>(`/api/temples/${id}`),
  createTemple: (body: Partial<Temple>) => http.post<ApiItemResponse<Temple>>("/api/temples", body),
  updateTemple: (id: string, body: Partial<Temple>) => http.patch<ApiItemResponse<Temple>>(`/api/temples/${id}`, body),
  listLandingPages: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<LandingPage>>("/api/landing-pages", query),
  getLandingPage: (id: string) => http.get<ApiItemResponse<LandingPage>>(`/api/landing-pages/${id}`),
  createLandingPage: (body: Partial<LandingPage>) => http.post<ApiItemResponse<LandingPage>>("/api/landing-pages", body),
  updateLandingPage: (id: string, body: Partial<LandingPage>) =>
    http.patch<ApiItemResponse<LandingPage>>(`/api/landing-pages/${id}`, body),
  publishLandingPage: (id: string) => http.post<ApiItemResponse<LandingPage>>(`/api/landing-pages/${id}/publish`),
  listShareCards: (query?: Record<string, string | number | undefined>) =>
    http.get<ApiListResponse<unknown>>("/api/share-cards", query),
  updateShareCard: (id: string, body: unknown) => http.patch<ApiItemResponse<unknown>>(`/api/share-cards/${id}`, body),
  listSpecialCards: () => http.get<ApiListResponse<unknown>>("/api/share-cards/special"),
  createSpecialCard: (body: unknown) => http.post<ApiItemResponse<unknown>>("/api/share-cards/special", body),
  getLanguages: () => http.get<ApiItemResponse<unknown>>("/api/platform/share-languages"),
  updateLanguages: (body: unknown) => http.put<ApiItemResponse<unknown>>("/api/platform/share-languages", body),
  getRegions: () => http.get<ApiItemResponse<unknown>>("/api/platform/regions-countries"),
  updateRegions: (body: unknown) => http.put<ApiItemResponse<unknown>>("/api/platform/regions-countries", body),
};
